module.exports = __webpack_public_path__ + "img/31a-indicadores-docs-por-situacao.8b3e3db0.png";